import type { promotionPopupsConfig } from '../config'
import type { PromotionPopupKey } from '@/contexts/SiteSpecificContext/popups/store'

import {
  useOnClosePopupFactory,
  useSitePromotionPopupsStoreFactory,
} from '@/contexts/SiteSpecificContext/popups/hooks'

export const useSitePromotionPopupsStore = () => {
  return useSitePromotionPopupsStoreFactory<typeof promotionPopupsConfig>()
}

export const useOnCloseBanner = (
  key: PromotionPopupKey<typeof promotionPopupsConfig>,
  callback: () => void,
) => {
  return useOnClosePopupFactory<typeof promotionPopupsConfig>(key, callback)
}

export const useCloseAndTerminatePromotionPopup = () => {
  const store = useSitePromotionPopupsStore()
  return {
    closeAndTerminatePromotionPopup: store.getState().closeAndTerminate,
  }
}
